export default __webpack_public_path__ + "static/media/CodingLab.4463444e.webp";